<template>
  <div class="table-container">
    <errors-list :errors="errorList" />
    <TableCommon
      title="字典数据"
      :checkbox-config="{ highlight: true }"
      :radio-config="{ highlight: true }"
      :custome-config="() => vxeShowCustom('xTable')"
    >
      <template #button>
        <table-button v-if="mode === 'add'" name="add" tip="新建" @click="addRow" />
        <table-button v-if="mode === 'add'" name="add" tip="删除" @click="removeRow" />
      </template>
      <vxe-grid
        ref="xTableEdit"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="300"
        max-height="500"
        align="center"
        size="mini"
        :checkbox-config="{ highlight: true }"
        :radio-config="{ highlight: true }"
        :empty-render="{ name: 'NotData' }"
        :toolbar-config="{ custom: true, size: 'mini' }"
        :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions.columns"
        :data="gridOptions.data"
      >
        <template #PRODUCT_ID="{ row, $rowIndex }">
          <el-input
            v-model.trim="row.PRODUCT_ID"
            placeholder="请选择产品"
            size="mini"
            readonly
          >
            <el-button slot="append" icon="el-icon-search" @click="openSelectDialog($rowIndex)" />
          </el-input>
        </template>
        <template #PRODUCT_NAME="{row}">
          <el-input v-model="row.PRODUCT_NAME" disabled size="mini" />
        </template>
      </vxe-grid>
    </TableCommon>
    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <product-select ref="dialogSelect" />
      </template>
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialog = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="submitHandle"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ProductSelect from '@/components/dialog/ProductSelect.vue'
export default {
  components: {
    ProductSelect
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    editRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      curIdx: 0,
      dialogTitle: '产品选择',
      showDialog: false,
      errorList: [],
      rowSeq: 0,
      gridOptions: {
        data: [],
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 },
          { field: 'PRODUCT_ID', title: '产品编号', slots: { default: 'PRODUCT_ID' } },
          { field: 'PRODUCT_NAME', title: '产品名称', slots: { default: 'PRODUCT_NAME' } }
        ]
      }
    }
  },
  created() {
    if (this.editRows.length) {
      this.gridOptions.data.push(
        ...this.editRows.map(item => {
          return { ...item }
        })
      )
    }
  },
  methods: {
    // 打开窗口
    openSelectDialog(idx) {
      this.curIdx = idx
      this.showDialog = true
    },
    submitHandle() {
      if (!this.$refs.dialogSelect) {
        this.showDialog = false
        return
      }
      this.$refs.dialogSelect.submitForm().then(res => {
        if (!res) {
          this.$message.warning('请选择产品')
          return
        }
        const row = this.gridOptions.data[this.curIdx]
        if (row) {
          row.PRODUCT_ID = res.PRODUCT_ID || res.productCode || ''
          row.PRODUCT_NAME = res.SHORT_TEXT || res.description || res.productShortName || ''
        }
        this.showDialog = false
      })
    },
    addRow() {
      this.gridOptions.data.push({
        PRODUCT_ID: '',
        PRODUCT_NAME: '',
      })
    },
    removeRow() {
      const checkedList = this.$refs['xTableEdit'].getCheckboxRecords()
      if (!checkedList.length) return

      checkedList.forEach(file => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    validRows() {
      try {
        if (!this.gridOptions.data.length) {
          throw new Error('请添加要保存的数据！')
        }
        this.gridOptions.data.forEach(item => {
          if (!item.PRODUCT_ID) {
            throw new Error('请输入完整的信息！')
          }
        })
      } catch (e) {
        this.$message.error(e.message)
        return false
      }

      return this.gridOptions.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/client-manage/components/producetDictEdit.vue